export default {
  methods: {
    getValueOf(key) {
      if (!this.paymentDetail || !this.paymentDetail.details) return '';

      const item = this.paymentDetail.details.find(item => item.description === key);
      if (!item || this.isEmpty(item.value)) return '';

      return item.value;
    },
    isEmpty(value) {
      return value === null || value === undefined || value === '';
    },
    isBoletoConcessionaria(value) {
      if (typeof value !== 'string') return false;
      return value.startsWith('83');
    },
    getStatusPayment(type) {
      switch (type) {
        case 'paid':
          return 'PAGO';
        case 'pending':
          return 'EM ABERTO';
        case 'canceled':
          return 'CANCELADO';
        case 'reproved':
          return 'REPROVADO';
        case 'chargeback':
          return 'ESTORNADO';
        default:
          break;
      }
    },
    statusColor(type) {
      return {
        'badge-success': type === 'paid' || type === 'chargeback',
        'badge-reproved': type === 'reproved',
        'badge-pending': type === 'pending',
        'badge-canceled': type === 'canceled',
      };
    },
    formatStringInFourParts(barcode) {
      const cleanString = barcode.replace(/\s/g, '');

      const totalLength = cleanString.length;
      const partSize = Math.ceil(totalLength / 4);

      const parts = [];
      for (let i = 0; i < 4; i++) {
        const start = i * partSize;
        const end = start + partSize;
        const part = cleanString.substring(start, end);
        if (part) {
          parts.push(part);
        }
      }

      return parts.join(' ');
    },
    formatBarcodeInGroups(barcode, groupSize) {
      const cleanString = barcode.replace(/\s/g, '');
      const parts = [];
      for (let i = 0; i < 4; i++) {
        const start = i * groupSize;
        const end = start + groupSize;
        const part = cleanString.substring(start, end);
        if (part) {
          parts.push(part);
        }
      }
      return parts.join(' ');
    },
    formatBarcodeForSEFAZ(barcode) {
      return this.formatBarcodeInGroups(barcode, 12);
    },
    formatBarcodeForIPVA(barcode) {
      return this.formatBarcodeInGroups(barcode, 12);
    },
    formatBarcodeForRFB(barcode) {
      let formattedBarcode = this.removeDV(barcode);
      return this.formatBarcodeInGroups(formattedBarcode, 11);
    },
    formatCompetencePeriod(period) {
      if (!period) return '';

      const cleanPeriod = period.replace(/\D/g, '');

      if (cleanPeriod.length === 6) {
        const month = cleanPeriod.substring(4, 6);
        const year = cleanPeriod.substring(0, 4);
        return `${month}/${year}`;
      }

      if (period.includes('/') && period.length === 7) {
        return period;
      }

      if (cleanPeriod.length === 4) {
        const month = cleanPeriod.substring(0, 2);
        const year = '20' + cleanPeriod.substring(2, 4);
        return `${month}/${year}`;
      }

      return period;
    },
    formatDocumentNumber(docNumber) {
      if (!docNumber) return '';
      const cleanNumber = docNumber.replace(/\D/g, '');
      if (cleanNumber.length >= 8) {
        return cleanNumber.replace(/(\d{3})(?=\d)/g, '$1.');
      }
      return docNumber;
    },
    getFieldDescription(field) {
      const fields = {
        Nsu: 'Id de pagamento no provedor',
        IssuerInstitutionName: 'Instituição Emissora',
        IssuerInstitutionCode: 'Código da Instituição Emissora',
        AgreementName: 'Nome do convênio',
        AgreementDocument: 'CNPJ do convênio',
        AgreementCode: 'Código do convênio',
        CompetencePeriod: 'Período de competência / exercício',
        RevenueCode: 'Código da receita',
        ControlNumber: 'Número de controle',
        VerificationPeriod: 'Período de apuração',
        OperationCode: 'Código de autenticação',
        DocumentNumber: 'Número do documento',
        Identifier: 'CPF/CNPJ ou Número identificador',
        PaymentCode: 'Código do pagamento',
        DareControlNumber: 'Número de controle do DARE',
        CityCode: 'Código do município',
        AiimNumber: 'Número AIIMS',
        CarPlate: 'Placa do veículo',
        Quota: 'Cota',
        ActiveDebtTagNumber: 'Inscrição na dívida ativa',
      };

      return fields[field] || '';
    },
    isReceiptType(type) {
      const agreementCode = this.getAgreementCode();
      return type === this.getPaymentReceiptType(agreementCode);
    },
    getAgreementCode() {
        const agreementCode = this.paymentDetail.details.find(item => item.description === 'AgreementCode');
        return agreementCode && agreementCode.value ? agreementCode.value : '';
    },
    isTypeDARF() {
      let billType = this.agreementCodeType();
      if(billType == 'DARF') return true;

      return false;
    },
    agreementCodeType() {
      const agreementCode = this.getAgreementCode();

      const codeMap = {
        DARF: ['0064', '0153', '0385'],
        GPS: ['0270'],
        DAS: ['0328'],
        DAE: ['0432'],
        FGTS: ['0179', '0180', '0239', '0240', '0451'],
        SEFAZ: ['0428'],
        IPVA: ['0025'],
      };

      for (const [type, codes] of Object.entries(codeMap)) {
        if (codes.includes(agreementCode)) {
          return type;
        }
      }

      return '';
    },
    showRevenueCode() {
        const agreementCode = this.getAgreementCode();

        const billTypes = ['0428', '0025'];
        return billTypes.includes(agreementCode);
    },
    showDocumentNumber() {
        const agreementCode = this.getAgreementCode();

        const billTypes = ['0185', '0428'];
        return billTypes.includes(agreementCode);
    },
    getPaymentReceiptType() {
      if(this.showRendimentoReceipt()) return 'ReceiptRendimento';

      const agreementItem = this.paymentDetail.details.find(item => item.description === 'AgreementCode');
      const agreementCode = agreementItem && agreementItem.value ? agreementItem.value : '';

      const categories = {
        'RFB': ['0064', '0153', '0270', '0328', '0385', '0432'],
        'FGTS': ['0179', '0180', '0239', '0240', '0451'],
        'SEFAZ': ['0428', '0025'],
      };

      if (categories.RFB.includes(agreementCode)) return 'CustomReceiptRFB';
      if (categories.FGTS.includes(agreementCode)) return 'CustomReceiptFGTS';
      if (categories.SEFAZ.includes(agreementCode)) return 'CustomReceiptSEFAZ';

      if(this.paymentDetail.barCode.startsWith('82') || this.paymentDetail.barCode.startsWith('83') || this.paymentDetail.barCode.startsWith('84'))
        return 'ReceiptUtilities';

      if(!this.paymentDetail.barCode.startsWith('8'))
        return 'ReceiptBill';

      return '';
    },
    showRendimentoReceipt() {
      return !(
        this.paymentDetail &&
        Array.isArray(this.paymentDetail.details) &&
        this.paymentDetail.details.length > 0
      );
    },
    formatDocument(doc) {
      if (!doc) return null;

      const digits = String(doc).replace(/\D/g, '');

      if (digits.length === 11) {
          return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (digits.length === 14) {
          return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
          return null;
      }
    },
    removeDV(barcode) {
      barcode = barcode.replace(/\D/g, '');

      let barcodeFormatted = '';

      for (let i = 0; i < 4; i++) {
        let bloco = barcode.substr(i * 12, 12);
        barcodeFormatted += bloco.substr(0, 11);
      }

      return barcodeFormatted;
    },
    formatDocumentNumber(number) {
      number = number.replace(/\D/g, '');

      return (
        number.substr(0, 2) + '.' +
        number.substr(2, 2) + '.' +
        number.substr(4, 5) + '.' +
        number.substr(9, 7) + '-' +
        number.substr(16)
      );
    },
  },
};
